/* External */
import {
  takeLatest, put, call, race, take,
} from 'redux-saga/effects';

/* ActionTypes */
import { SEARCH, STOP_AUTHENTICATED_SAGAS } from './actionTypes';

/* Actions */
import { addToEntities } from './actions';

/* Sagas */
import { requestSaga } from '../requests/sagas';

/* Services */
import backendService from '../../services/backendService';

export default [
  search,
];

function* search() {
  yield takeLatest(SEARCH, searchSaga);
}

function* searchSaga(action) {
  try {
    const response = yield call(requestSaga, searchService, action);
    if (response) {
      const { normalizedData: { entities } } = response;
      yield put(addToEntities(entities));
    }
  } catch (error) {
    console.error('shows>searchSaga', error);
  }
}

function searchService({ query, count }) {
  return backendService.content.v1.searchAssets({ query, count });
}

export function authenticatedSaga(sagaToRun) {
  return function* raceWithStopAuthenticated(...args) {
    yield race([
      sagaToRun(...args),
      take(STOP_AUTHENTICATED_SAGAS),
    ]);
  };
}

export function enqueuedSaga(sagaToRun) {
  let first;
  let last;

  function* performSaga() {
    while (first) {
      yield call(sagaToRun, ...first.args);
      first = first.next;
    }
  }

  return function* enqueue(...args) {
    const node = { args, next: undefined };
    if (first) {
      last.next = node;
      last = node;
    } else {
      first = node;
      last = node;
      yield performSaga();
    }
  };
}
